export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.woff2?c967a94cfbe2b06627ffe7861c741a61";